import { useTranslation } from 'react-i18next';

const trustItems = [
  { icon: 'ri-secure-payment-line', key: 'trust_no_deposit_detail' },
  { icon: 'ri-hand-coin-line', key: 'trust_pay_onsite_detail' },
  { icon: 'ri-award-line', key: 'trust_licensed_detail' },
  { icon: 'ri-chat-voice-line', key: 'trust_german_detail' },
  { icon: 'ri-car-line', key: 'trust_private_detail' },
  { icon: 'ri-price-tag-3-line', key: 'trust_transparent_detail' },
  { icon: 'ri-user-heart-line', key: 'trust_individual_detail' },
  { icon: 'ri-whatsapp-line', key: 'trust_support_detail' },
];

export default function TrustSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-primary-900 py-10 md:py-12">
      <div className="w-full px-4 md:px-6 lg:px-12 xl:px-20">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 text-center mb-8">
          {t('trust_section_title')}
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {trustItems.map((item) => (
            <div
              key={item.key}
              className="flex flex-col items-center justify-center text-center gap-4 p-5 md:p-6 h-full bg-primary-800/40 border border-primary-700/30 rounded-sm hover:border-accent-500/40 transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-accent-400 text-2xl`} />
              </div>
              <span className="text-sm font-medium text-background-200 leading-relaxed px-1">
                {t(item.key)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}